import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Pagination from '../../../shared/components/Pagination';
import RecruitItem from '../../../shared/components/RecruitItem';
import { decodeToken, formatNumberWithCommas } from '../../../utils';
import PAEAA060 from '../../Recruit/PAEAA010/popupPAEAA060';

const SearchRecruits = ({ list, pages, setListData }) => {
    const [popupData, setPopupData] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);

    const openPopup = (data) => {
        if (decode?.authorities === 'ROLE_P') {
            setPopupData(data);
            setIsPopupOpen(true);
        } else if (decode?.authorities === 'ROLE_C') {
            window.alert('개인회원만 이용가능합니다.');
        } else {
            window.alert('로그인 후 이용가능합니다.');
        }
    };

    const closePopup = () => {
        setPopupData(null);
        setIsPopupOpen(false);
    };

    return (
        <>
            <div id="recruitment-news">
                <div className="top-table">
                    <div className="count-results">
                        채용정보{' '}
                        <span>
                            총 <span className="high-light-number">{formatNumberWithCommas(pages.totalRow)}</span>건
                        </span>
                    </div>
                    <Link to="/paeaa010" className="more-results blue">
                        채용정보 보기 &gt;
                    </Link>
                </div>
                <ul className="table wrap-table table-yellow">
                    {list.map((item, index) => (
                        <RecruitItem
                            item={item}
                            key={index}
                            saveHistory={true}
                            openPopup={openPopup}
                            setRecruitList={setListData}
                            showStar={true}
                            roleAction="P"
                        />
                    ))}
                </ul>
                <Pagination pages={pages} params="pageRecruit" />
            </div>
            {isPopupOpen && <PAEAA060 popupData={popupData} closePopup={closePopup} />}
        </>
    );
};

export default SearchRecruits;
